export function getDiscountedPrice(realPrice, discount) {
  const price = parseFloat(realPrice ?? 0);
  const disc = parseFloat(discount ?? 0);
  return parseFloat((price * (1 - disc / 100)).toFixed(2));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(value);
}
